import { useEffect } from "react";
import { Container, Skeleton } from "@/components/atoms";
import { ClientsActionMenu, ClientsImportPanel, ClientsModals, PageHeaderV2 } from "@/components/organisms";
import { ClientsTable } from "@/components/organisms/Clients/ClientsTable";
import { useGetClientsParams } from "@/components/organisms/Clients/useGetClientsParams";
import { useGetClientsQuery } from "@/redux/apis/client/clientApi";
import { useAppSelector } from "@/redux/hooks";
import { clientsSelector } from "@/redux/slices/client/selectors";
import { OnboardingClientsSection } from "@/redux/slices/onboarding/types";
import { selectCameFromQuickSetup, selectLastClickedSection } from "@/redux/slices/quickSetup/selectors";
import { ClientsTabs } from "./ClientsTabs";
import { useClientsContext } from "./context";
import { ClientsFilters } from "./features/Filters/ClientsFilters";

export const ClientsPanel = () => {
  const { step, setStep } = useClientsContext();
  const { params } = useGetClientsParams();
  const { isFetching, refetch } = useGetClientsQuery(params, { refetchOnMountOrArgChange: true });
  const clients = useAppSelector(clientsSelector);
  const cameFromQuickSetup = useAppSelector(selectCameFromQuickSetup);
  const lastClickedSection = useAppSelector(selectLastClickedSection);

  useEffect(() => {
    if (cameFromQuickSetup && lastClickedSection === OnboardingClientsSection.UPLOAD_CLIENTS) {
      setStep("import");
    }
  }, [cameFromQuickSetup, lastClickedSection, setStep]);

  return (
    <Container className="mb-12 flex w-full flex-1 flex-col">
      <PageHeaderV2 name="Clients" skipCrumbs={1} showDivider={false}>
        <ClientsActionMenu />
      </PageHeaderV2>
      <ClientsTabs className="-mx-3 mt-3 border-b border-neutral-mid-gray px-3 lg:-mx-5 lg:px-5" />
      <ClientsFilters.ActiveFilters className="mt-2" />
      {isFetching ? (
        <Skeleton />
      ) : (
        <div>
          <ClientsTable items={clients} />
          <ClientsTable.Pagination />
        </div>
      )}
      <ClientsModals />
      <ClientsImportPanel open={step === "import"} onClose={() => setStep(undefined)} refetchClients={() => refetch()} />
    </Container>
  );
};
